import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import { listingApi } from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  PRODUCER,
} from './constants';

function* storeProducer(data = {}, merge = true) {
  yield put({
    type: PRODUCER.update,
    data,
    merge,
  });
}

function* fetchProducer({
  data,
}) {
  yield* storeProducer(data);
}

function* updateProducer({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'producer',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeProducer({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'producer',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      yield* storeProducer({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess);
  } catch (error) {
    yield* storeProducer();
    errorHandler('Thất bại', error);
  }
}

function* removeProducer({
  _id,
}) {
  const {
    producer,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'producer',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(producer.data);
    delete newData[_id];
    yield* storeProducer(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeProducer();
    errorHandler('Thất bại', error);
  }
}

function* importProducer({
  data = [],
}) {
  const {
    producer,
  } = yield select();
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'producer',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const newData = cloneDeep(producer.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeProducer(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* producerSaga() {
  yield all([
    yield takeEvery(PRODUCER.handlers.fetch, fetchProducer),
    yield takeEvery(PRODUCER.handlers.update, updateProducer),
    yield takeEvery(PRODUCER.handlers.import, importProducer),
    yield takeEvery(PRODUCER.handlers.remove, removeProducer),
  ]);
}
